var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable, action } from 'mobx';
import { BaseMandate } from './index';
import Mandate from './Mandate';
export default class CustomerMandate extends BaseMandate {
    constructor({ redisId, firstName, lastName, communicationLanguageCode, personalCode, personalCodeCountryCode, birthday, mandates }) {
        super();
        Object.defineProperty(this, "firstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communicationLanguageCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personalCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personalCodeCountryCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "birthday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return !!(this.isPersonValid && this.communicationLanguageCode) && this.mandates.length > 0;
            }
        });
        Object.defineProperty(this, "getName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return `${this.firstName} ${this.lastName}`;
            }
        });
        Object.defineProperty(this, "doesNotBelongToRepresentativeCustomer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customer) => {
                return !customer || customer.registrationNumber !== this.personalCode || customer.registrationNumberCountryCode !== this.personalCodeCountryCode;
            }
        });
        makeObservable(this);
        this.setValues({ redisId, firstName, lastName, communicationLanguageCode, personalCode, personalCodeCountryCode, birthday, mandates });
    }
    setValues({ redisId, firstName, lastName, communicationLanguageCode, personalCode, personalCodeCountryCode, birthday, mandates }) {
        this.redisId = redisId;
        this.firstName = firstName || '';
        this.lastName = lastName || '';
        this.communicationLanguageCode = communicationLanguageCode;
        this.personalCode = personalCode;
        this.personalCodeCountryCode = personalCodeCountryCode || 'EE';
        this.birthday = birthday;
        this.mandates = (mandates && mandates.map((mandate) => new Mandate(mandate))) || [];
    }
    get isPersonValid() {
        return !!(this.firstName && this.lastName && this.personalCode && this.personalCodeCountryCode);
    }
}
__decorate([
    observable
], CustomerMandate.prototype, "firstName", void 0);
__decorate([
    observable
], CustomerMandate.prototype, "lastName", void 0);
__decorate([
    observable
], CustomerMandate.prototype, "communicationLanguageCode", void 0);
__decorate([
    observable
], CustomerMandate.prototype, "personalCode", void 0);
__decorate([
    observable
], CustomerMandate.prototype, "personalCodeCountryCode", void 0);
__decorate([
    observable
], CustomerMandate.prototype, "birthday", void 0);
__decorate([
    action
], CustomerMandate.prototype, "setValues", null);
__decorate([
    computed
], CustomerMandate.prototype, "isPersonValid", null);
